export class ExtinguishingBottles {
    constructor() {
        this.bottlesCount = null;
        this.volume = null;
        this.lastMinPressure = null;
        this.lastMaxPressure = null;
        this.lastMinConcessionTemperature = null;
        this.lastMaxConcessionTemperature = null;

        this.coverageNotAvailable = false;
        this.coverageNotAvailableReason = null;
        this.coverageArt = '';
        this.coveragePressure = '';
        this.materialCode = '';
        this.testPressure = null;
        this.lastTestDate = null;
    }
}
